import { useGetAllTypesQuery } from '../../api/api-hooks';

const useSoftwareSoldMiddleware = () => {
  const { data: types } = useGetAllTypesQuery({});
  if (types === undefined)
    return (
      name: string,
      value: string,
      state: any,
      autoboxValue?: object,
      autoboxLabel?: string
    ) => ({});
  return (
    name: string,
    value: string,
    state: any,
    autoboxValue?: object,
    autoboxLabel?: string
  ) => {
    if (name === 'supportStartDate') {
      // @ts-ignore
      if (state.supportEndDate && state.supportEndDate < value) {
        return { supportStartDate: state.supportStartDate };
      } else {
        return {};
      }
    } else if (name === 'supportEndDate') {
      // @ts-ignore
      if (state.supportStartDate > value) {
        return { supportEndDate: state.supportEndDate };
      } else {
        return {};
      }
    } else if (name && name.startsWith('moduleLicense')) {
      const index = Number(name.slice(13));
      const moduleArrayCopy = [...state.modulesToAdd];
      moduleArrayCopy[index] = {
        module: moduleArrayCopy[index].module,
        license: value,
      };
      return { modulesToAdd: moduleArrayCopy };
    }
    if (autoboxLabel) {
      if (autoboxLabel === 'hardware') {
        if (autoboxValue) {
          // @ts-ignore
          const value = autoboxValue?.serial;
          if (
            value &&
            (value.startsWith('04') ||
              value.startsWith('08') ||
              value.startsWith('16') ||
              value.startsWith('D4'))
          )
            return {
              manufacturer: 'LP Technologies',
              hardware: autoboxValue,
            };
          else return { hardware: autoboxValue };
        } else return { hardware: autoboxValue };
      }
    }
    if (autoboxLabel === 'company') {
      return { company: autoboxValue };
    }
    if (autoboxLabel === 'software') {
      return { software: autoboxValue };
    }
    if (autoboxLabel === 'order') {
      return { order: autoboxValue };
    }
    if (autoboxLabel === 'newModule')
      return {
        modulesToAdd: [...state.modulesToAdd, { module: null, license: '' }],
      };
    if (autoboxLabel === 'deleteModule') {
      const index = Number(autoboxValue);
      return {
        modulesToAdd: state.modulesToAdd
          .slice(0, index)
          .concat(state.modulesToAdd.slice(index + 1)),
      };
    }
    if (autoboxLabel?.startsWith('modulesToAdd')) {
      const index = Number(autoboxLabel.slice(12));
      const moduleArrayCopy = [...state.modulesToAdd];
      moduleArrayCopy[index] = { module: autoboxValue, license: '' };
      return { modulesToAdd: moduleArrayCopy };
    }
    return {};
  };
};

export default useSoftwareSoldMiddleware;
